import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { ShieldCheck, CheckCircle, XCircle, Warning } from "@phosphor-icons/react";

const LABELS = { pasien: "Pasien (NIK + IHS)", petugas: "Petugas (IHS Practitioner)", lokasi: "Lokasi (IHS Location)", encounter: "Encounter", diagnosis: "Diagnosis (ICD-10)", resep: "Resep (KFA)", lab: "Hasil Lab (LOINC)" };
const CONF = [["base_url", "Base URL"], ["client_id", "Client ID"], ["client_secret", "Client Secret"], ["organization_id", "Organization ID"]];

export default function SatusehatReadiness() {
  const [data, setData] = useState(null);
  useEffect(() => {
    document.title = "Kesiapan SATUSEHAT — HalloGBS";
    api.get(`/satusehat/readiness`).then((r) => setData(r.data)).catch((e) => toast.error(apiError(e)));
  }, []);

  if (!data) return <div className="p-10 text-center text-sm text-slate-400" data-testid="satusehat-loading">Memuat…</div>;

  return (
    <div className="space-y-6" data-testid="satusehat-readiness">
      <div>
        <h1 className="flex items-center gap-2 font-heading text-2xl font-extrabold text-[#4C1D95]"><ShieldCheck size={24} weight="duotone" className="text-[#DB2777]" /> Kesiapan SATUSEHAT</h1>
        <p className="mt-1 text-sm text-slate-500">Pemeriksa <b>read-only</b>. Tidak melakukan koneksi/kirim ke SATUSEHAT. Nilai konfigurasi tidak pernah ditampilkan.</p>
      </div>

      <div className="rounded-2xl border border-pink-100 bg-white p-4" data-testid="satusehat-config">
        <p className="mb-3 text-xs font-bold uppercase text-slate-500">Konfigurasi (masked)</p>
        <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
          {CONF.map(([k, lbl]) => (
            <div key={k} data-testid={`conf-${k}`} className={`rounded-xl border p-3 text-center ${data.config[k] ? "border-emerald-200 bg-emerald-50" : "border-rose-200 bg-rose-50"}`}>
              {data.config[k] ? <CheckCircle size={20} weight="fill" className="mx-auto text-emerald-600" /> : <XCircle size={20} weight="fill" className="mx-auto text-rose-500" />}
              <p className="mt-1 text-[11px] font-bold text-slate-600">{lbl}</p>
              <p className={`text-[11px] font-bold ${data.config[k] ? "text-emerald-700" : "text-rose-600"}`}>{data.config[k] ? "Tersedia" : "Belum diisi"}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="space-y-3">
        {Object.entries(data.categories).map(([key, c]) => (
          <div key={key} data-testid={`cat-${key}`} className="rounded-2xl border border-pink-100 bg-white p-4">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <p className="font-heading font-bold text-slate-800">{LABELS[key] || key}</p>
              <div className="flex items-center gap-2 text-xs font-bold">
                <span className="rounded-full bg-emerald-100 px-2 py-0.5 text-emerald-700" data-testid={`ready-${key}`}>Siap {c.ready}</span>
                <span className="rounded-full bg-rose-100 px-2 py-0.5 text-rose-600" data-testid={`notready-${key}`}>Belum {c.not_ready}</span>
                <span className="rounded-full bg-slate-100 px-2 py-0.5 text-slate-500">Total {c.total}</span>
              </div>
            </div>
            {Object.entries(c.reasons || {}).filter(([, n]) => n > 0).length > 0 && (
              <div className="mt-2 flex flex-wrap gap-1.5">
                {Object.entries(c.reasons).filter(([, n]) => n > 0).map(([r, n]) => (
                  <span key={r} className="flex items-center gap-1 rounded-lg bg-amber-50 px-2 py-1 text-[11px] font-semibold text-amber-700"><Warning size={12} weight="fill" /> {r}: {n}</span>
                ))}
              </div>
            )}
            {c.detail && c.detail.length > 0 && (
              <div className="mt-2 space-y-1" data-testid={`detail-${key}`}>
                <p className="text-[11px] font-bold uppercase text-slate-400">Contoh (No. RM dimask)</p>
                {c.detail.map((d, i) => (
                  <p key={i} className="text-[11px] text-slate-500"><span className="font-mono font-bold text-slate-600">{d.ref}</span> — {d.issues.join("; ")}</p>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
